import { useCallback } from 'react';
import { useGameStore } from '@/store/gameStore';
interface HUDProps {
  isPaused?: boolean;
  onTogglePause?: () => void;
}
export function HUD({ isPaused = false, onTogglePause }: HUDProps) {
  const score = useGameStore((s) => s.score);
  const highScore = useGameStore((s) => s.highScore);
  const handlePause = useCallback(() => {
    onTogglePause?.();
  }, [onTogglePause]);
  return (
    <div className="absolute top-0 left-0 right-0 flex justify-between items-start px-4 pt-4 pointer-events-none z-10">
      <div className="flex flex-col">
        <span className="text-xs text-slate-500 uppercase tracking-widest">Score</span>
        <span className="text-2xl font-black text-white tabular-nums">{score}</span>
      </div>
      <button
        onClick={handlePause}
        className="pointer-events-auto w-9 h-9 flex items-center justify-center rounded-lg bg-slate-800/70 hover:bg-slate-700/80 active:scale-95 transition-all duration-150"
        aria-label={isPaused ? "Resume" : "Pause"}
      >
        <span className="text-slate-300 text-sm">
          {isPaused ? "▶" : "⏸"}
        </span>
      </button>
      {highScore > 0 && (
        <div className="flex flex-col items-end">
          <span className="text-xs text-slate-500 uppercase tracking-widest">Best</span>
          <span className="text-2xl font-black text-yellow-400 tabular-nums">{highScore}</span>
        </div>
      )}
    </div>
  );
}